import { useTranslation } from 'libs/i18n';
import { Section } from 'modules/client/common/components';

import { FormContent, FormContentProps } from './FormContent';

interface Props extends FormContentProps {}

export const TargetedFinancialInstrumentsSection = ({
  ...formProps
}: Props) => {
  const { t } = useTranslation();
  return (
    <Section
      datax="targetedFinancialInstrumentsSection"
      title={t('client.legal.targetedFinancialInstruments.title')}
    >
      <FormContent {...formProps} />
    </Section>
  );
};
